import { useProductSummary } from '../hooks/useProductSummary';

type ClearLinkProps = { children: React.ReactNode };

const ClearLink = ({ children }: ClearLinkProps) => {
	const { blockClass } = useProductSummary();

	return (
		<span
			className={`clearLink clearLink--${blockClass} vtex-product-summary-2-x-clearLink vtex-product-summary-2-x-clearLink--${blockClass} h-100 flex flex-column`}
			style={{ cursor: 'pointer' }}
		>
			{children}
		</span>
	);
};

export default ClearLink;
